import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  for: "company-proformaPrefix",
  class: "col-lg-4 col-xxl-3 col-form-label"
}, " Prefix proformy ", -1)
const _hoisted_3 = { class: "col-lg-8 col-xxl-9" }
const _hoisted_4 = { class: "invalid-feedback" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom pt-4 mb-4 d-none d-lg-block" }, null, -1)
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "company-textOnInvoiceBottom",
  class: "col-lg-4 col-xxl-3 col-form-label"
}, " Text v patičce faktury ", -1)
const _hoisted_8 = { class: "col-lg-8 col-xxl-9" }
const _hoisted_9 = { class: "invalid-feedback" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom pt-4 mb-4 d-none d-lg-block" }, null, -1)
const _hoisted_11 = { class: "text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_SubmitButton = _resolveComponent("SubmitButton")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    "initial-values": _ctx.company,
    onSubmit: _ctx.onSubmit,
    class: "p-4 p-lg-5 bg-white rounded-3 border"
  }, {
    default: _withCtx(({ errors }) => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Field, {
            class: _normalizeClass([{ 'is-invalid' : errors.proformaPrefix }, "form-control"]),
            type: "text",
            name: "proformaPrefix",
            id: "company-proformaPrefix"
          }, null, 8, ["class"]),
          _createElementVNode("div", _hoisted_4, _toDisplayString(errors.proformaPrefix), 1)
        ])
      ]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Field, {
            class: _normalizeClass([{ 'is-invalid' : errors.textOnInvoiceBottom }, "form-control"]),
            as: "textarea",
            name: "textOnInvoiceBottom",
            id: "company-textOnInvoiceBottom"
          }, null, 8, ["class"]),
          _createElementVNode("div", _hoisted_9, _toDisplayString(errors.textOnInvoiceBottom), 1)
        ])
      ]),
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_SubmitButton, {
          "btn-title": "Uložit změny",
          loading: _ctx.loading,
          classes: "w-100 w-lg-auto mt-3 px-4 mt-lg-0"
        }, null, 8, ["loading"])
      ])
    ]),
    _: 1
  }, 8, ["initial-values", "onSubmit"]))
}